export default {
  /**
   * 已开放银行代码
   * CMB 招行
   * CCB 建行
   * SPD 浦发
   * PINGAN 平安
   * BOC 中行
   * BCM 交行
   * */
  ReadyBankCode: ['CMB', 'CCB', 'SPD', 'PINGAN', 'BOC'],
  BizStatusOptions: [
    {
      name: '未评估',
      value: 'P',
    },
    {
      name: '评估中',
      value: 'R',
    },
    {
      name: '评估通过',
      value: 'SUCCEED',
    },
    {
      name: '评估不通过',
      value: 'FAILED',
    }
  ],
};
